import React from 'react';

import { ReactComponent as Marker } from 'assets/icons/currentLocationMarker.svg';

const MyMarker = () => {
  return <Marker />;
};

export default MyMarker;
